// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1757":"70d7f638","2112":"66dd4636","7879":"d1ed05b2","9369":"7174dc9e"}[chunkId] + ".chunk.css";
};